export default "__VITE_ASSET__BUqC_1XV__"